import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const Select = ({
  label,
  error,
  value,
  onChange,
  options,
  required = false,
  placeholder,
  className = '',
  ...props
}) => {
  const { t, isRTL } = useLanguage();

  return (
    <div className="space-y-1">
      {label && (
        <label className={`block text-sm font-medium text-gray-700 ${isRTL ? 'text-right' : 'text-left'}`}>
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <select
        value={value || ''}
        onChange={onChange}
        className={`
          w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
          focus:outline-none focus:ring-2 focus:ring-minecraft-green focus:border-minecraft-green
          ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : ''}
          ${isRTL ? 'text-right' : 'text-left'}
          ${className}
        `}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className={`text-sm text-red-600 ${isRTL ? 'text-right' : 'text-left'}`}>
          {t(error)}
        </p>
      )}
    </div>
  );
};

export default Select;